module.exports = ".wrapper {\n  padding: 40px;\n}\n"